import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "@dr.pogodin/react-helmet";
import FeedbackSlider from "../../Components/ReviewSlider";

export default function OurTeam() {
   useEffect(() => {
        if (typeof window !== "undefined") {
            document.title = "Best Website Hosting Services | 24/7 Support";
            import("sal.js").then(({ default: sal }) => {
            sal();
            });
        }
    }, []);
  const allTeam = [
    {
      indexKey: 1,
      img: "images/kuldeep-negi.jpg",
      name: "Kuldeep Negi",
      role: "Director/CEO",
      quote: "Leading with clarity. Growing with purpose.",
      instagram: "https://www.instagram.com/kuldeepinfinitivehost/",
      facebook: "https://www.facebook.com/kuldeep.negi.73",
      linkdin: "https://www.linkedin.com/in/kuldeep-negi-91635a2b/",
      twitter: "https://x.com/kuldeepstrength"
    },
    {
      indexKey: 2,
      img: "images/archana-negi.jpg",
      name: "Archna Negi",
      role: "Co-founder/Social Media Manager",
      quote: "Responsible for expanding processes.",
      instagram: "https://www.instagram.com/archna_infinitivehost/",
      linkdin: "https://www.linkedin.com/in/archna-rawat-0227685b/"
    },
    {
      indexKey: 3,
      img: "images/gajendra.webp",
      name: "Gajendra Singh",
      role: "CTO",
      quote: "Turn all your dreams into bulletproof systems.",
    },
    {
      indexKey: 4,
      img: "images/hr.jpg",
      name: "Savita Shah",
      role: "HR",
      quote: "Connect hearts, talents, and success strategies.",
    },
    {
      indexKey: 5,
      img: "images/senior-linux-system-admin-2.jpg",
      name: "Aamir Ali",
      role: "Sr. Linux System Admin",
      quote: "Architect of reliability, guardian of performance.",
    },
    {
      indexKey: 6,
      img: "images/ashish.png",
      name: "Ashish Yadav",
      role: "Sr. Linux System Admin",
      quote: "Keep systems silent, stable, & unstoppable.",
    },
    {
      indexKey: 7,
      img: "images/graphic-designer.jpg",
      name: "Jitendra Kumar",
      role: "Sr. Graphic Designer",
      quote: "Bring concepts to life beautifully.",
    },
    {
      indexKey: 8,
      img: "images/business-analyst.jpg",
      name: "Batul Sharma",
      role: "Business Analyst",
      quote: "Find meaning between numbers and needs.",
    },
    {
      indexKey: 9,
      img: "images/account-executive.jpg",
      name: "Tanu Kumawat",
      role: "Accountant",
      quote: "Keep finances honest and future-ready.",
    },
    {
      indexKey: 10,
      img: "images/deeksha-seo-executive.jpg",
      name: "Deeksha Kumawat",
      role: "Sr. SEO and Social media Executive",
      quote: "Help brands to get found and remembered.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Our Team |  Innovative & Experienced Professionals</title>
        <meta name="description" content="Infinitive Host has a team of highly skilled and motivated employees. We work 24/7 to offer the best services to our customers." />
        <meta name="keywords" content="our team, team members, company staff, team roles, collaborative team, skilled professionals, team expertise, meet the team, team achievements" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/our-team`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/our-team`} />
        <meta property="og:title" content="Our Team | Innovative & Experienced Professionals"></meta>
        <meta property="og:description" content="Infinitive Host has a team of highly skilled and motivated employees. We work 24/7 to offer the best services to our customers."></meta>
      </Helmet>

      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">One Team. One Vision.</span>
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Our Core Team</h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    A professional team of creators, techies, and problem-solvers-working in a team to build exceptional hosting experiences every day.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="our-team-section pt-100 pb-100 gray-light-bg">
            <div className="container">
                <div className="row">
                    {allTeam.map((member, index) => (
                      <div className="col-md-6 col-lg-3" key={member.indexKey}>
                          <div className="staff-member mt-4">
                              <div className="card text-center border-0 shadow-sm">
                                  <img src={member.img} alt={member.name} className="card-img-top" />
                                  <div className="card-body">
                                      <h5 className="h5 teacher mb-0">{member.name}</h5>
                                      <span>{member.role}</span>
                                  </div>
                              </div>
                              <div className="overlay d-flex align-items-center justify-content-center">
                                  <div className="overlay-inner">
                                      <p className="teacher-quote"></p>{member.quote}
                                          <h5 className="mb-0 teacher text-white">{member.name}</h5>
                                      <span className="teacher-field text-white">{member.role}</span>
                                      <ul className="list-inline py-4 social">
                                          {member.facebook && (
                                            <li className="list-inline-item"><a href={`${member.facebook}`} target="_blank"><span className="fab fa-facebook-f"></span></a></li>
                                          )}
                                          {member.linkdin && (
                                            <li className="list-inline-item"><a href={`${member.linkdin}`} target="_blank"><span className="fa-brands fa-linkedin-in"></span></a></li>
                                          )}
                                          {member.instagram && (
                                            <li className="list-inline-item"><a href={`${member.instagram}`} target="_blank"><span className="fa-brands fa-instagram"></span></a></li>
                                          )}
                                          {member.twitter && (
                                            <li className="list-inline-item"><a href={`${member.twitter}`} target="_blank"><span className="fa-brands fa-x"></span></a></li>
                                          )}
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                    ))}
                </div>
            </div>
        </section>
        <section className="pt-60 pb-60">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-8">
                  <span className="section-title style-bg fadeInUp">Reviews</span>
                  <h2
                  data-sal="slide-up"
                  data-sal-duration="500"
                  data-sal-delay="200"
                  data-sal-easing="ease-in-out-sine"
                  >
                  Voices of Clients-Hear How We Stand Out!
                  </h2>
              </div>
            </div>
            <FeedbackSlider />
          </div>
        </section>

    </>
  );
}
